import { Type } from '@angular/core';

import { getDefaultBaseOptions, BaseSpecOptions } from '../base/options';
import { merge } from '../internals/merge';
import { OptionalsRequired } from '../types';

export interface SpecHttpOptions<S> extends BaseSpecOptions {
  service: Type<S>;
}

const defaultHttpOptions: OptionalsRequired<SpecHttpOptions<any>> = {
  ...getDefaultBaseOptions()
};

/**
 * @internal
 */
export function getDefaultHttpOptions<S>(overrides: SpecHttpOptions<S>): Required<SpecHttpOptions<S>> {
  return merge(defaultHttpOptions, overrides);
}
